// extracted by mini-css-extract-plugin
export default {"form":"EditSermonForm_form__4-Bzv","buttonRow":"EditSermonForm_buttonRow__rQZMT"};